import React from 'react'
import { CheckBoxGroup as CheckBoxGroupG } from 'grommet'
import styled from 'styled-components'
import { device } from '../../theme/device'

const CheckBoxGroup = styled(CheckBoxGroupG)`
  display: flex;
  flex-wrap: wrap;
  row-gap: 0.5rem;
  justify-content: center;
  & > label > div {
    & > div {
      box-shadow: none;
      height: 24px;
      width: 24px;
      @media ${device.medium} {
        height: 22px;
        width: 22px;
      }
    }
  }
`

const CheckBoxList = ({
  name,
  options,
  value,
  onChange,
  disabledOptions = [],
}) => {
  return (
    <CheckBoxGroup
      direction="row"
      name={name}
      options={options.map(option => ({
        label: option,
        value: option,
        disabled: disabledOptions.includes(option),
      }))}
      value={value}
      onChange={onChange}
      background="baseBackground"
      pad=".5rem 0"
    />
  )
}

export default CheckBoxList
